import PropTypes from 'prop-types';
import TooltipService from '../services/tooltip-service';

export default PropTypes.oneOf(TooltipService.getValidPositions());
